import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var SocialInstagram = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 100 100"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M67.961 45.288c0 9.919-8.041 17.96-17.96 17.96s-17.96-8.041-17.96-17.96c0-2.795.657-5.43 1.795-7.788H14v42c0 3.85 3.15 7 7 7h58c3.85 0 7-3.15 7-7v-42H66.165a17.848 17.848 0 011.796 7.788zM79 13.5H21c-3.85 0-7 3.15-7 7v14h21.665c3.278-4.349 8.47-7.172 14.335-7.172s11.057 2.823 14.335 7.172H86v-14c0-3.85-3.15-7-7-7zM19.756 31.216H17.15V21.121a4.253 4.253 0 012.607-3.922v14.017zm4.27 0h-2.469V16.868h2.469v14.348zm4.269 0h-2.469V16.868h2.469v14.348zm4.266-10.095v10.095h-2.466V16.868h2.466v4.253zm49.79 5.842a4.252 4.252 0 01-4.251 4.253h-6.909a4.252 4.252 0 01-4.252-4.253v-5.842a4.252 4.252 0 014.252-4.253H78.1a4.251 4.251 0 014.251 4.253v5.842z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.001 61.148c8.736 0 15.818-7.085 15.818-15.819 0-8.735-7.081-15.82-15.818-15.82-8.738 0-15.82 7.085-15.82 15.82 0 8.733 7.082 15.819 15.82 15.819zM50 32.725c6.96 0 12.604 5.643 12.604 12.604 0 6.96-5.643 12.604-12.604 12.604S37.396 52.29 37.396 45.329C37.397 38.367 43.04 32.725 50 32.725z"
  })));
});
SocialInstagram.displayName = 'SocialInstagram';
export var SocialInstagramDimensions = {
  height: 100,
  width: 100
};